module.exports = __webpack_public_path__ + "img/bg3.bf8f04f5.jpg";